import { Component, OnInit } from '@angular/core';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-cricket-tournament',
  templateUrl: './cricket-tournament.component.html',
  styleUrls: ['./cricket-tournament.component.scss']
})
export class CricketTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

    ngAfterViewInit() {
      /*---------------------------
      :: lightBox Gallery
      -----------------------------*/
   
      let galerias = document.getElementsByClassName('video-gallery');
      for (let i = 0; i < galerias.length; i++) {
        galerias[i].id = 'gal' + i; 
        lightGallery(document.getElementById('gal' + i), {
          selector: 'a',
        });
      } 
      
      let gall_image = document.getElementsByClassName('lightgallery');
      for (const gal of gall_image) {
        lightGallery(gal), {
          selector: 'a',
        }
      }
  
    }
  }



